import React from 'react';
import { buildClassName } from '../../../utils';
import { DropdownItem } from './DropdownItem';
import type { MenuItem } from '../../../types';
import styles from '../DesktopNavigation.module.scss';

interface DropdownMenuProps {
  items: MenuItem[] | undefined;
  expandedItems: Set<string>;
  onToggleExpanded: (itemId: string) => void;
  onItemClick: (item: MenuItem) => void;
  styleOverrides?: {
    dropdown?: string;
  };
}

export const DropdownMenu = ({ 
  items, 
  expandedItems, 
  onToggleExpanded, 
  onItemClick,
  styleOverrides = {},
}: DropdownMenuProps) => {
  return (
    <div className={buildClassName(styles.dropdown, styleOverrides.dropdown)}>
      <div className={styles.menuItems}>
        <ul>
          {/* Map through all dropdown items and render appropriate component */}
          {items?.map(item => (
            <DropdownItem
              key={item.id}
              item={item}
              expandedItems={expandedItems}
              onToggleExpanded={onToggleExpanded}
              onItemClick={onItemClick}
            />
          ))}
        </ul>
      </div>
    </div>
  );
}; 